import React from 'react';
import { Input } from "antd";
import { ISearchView } from "./types/search-engine.types";
import { Search } from "lucide-react";
import SearchResultItem from "./components/SearchResultItem";
import { Empty } from "antd/lib";

const SearchView: React.FC<ISearchView> = (props) => {


    return (
        <div className={'search-bar-wrapper'}>
            <Input
                ref={props.inputRef}
                className={'search-bar'}
                value={props.searchQuery}
                prefix={<Search/>}
                placeholder="Search Links ...."
                onClick={() => props.onInputClick()}
                onChange={(e) => props.onSearch(e.target.value)}
                onKeyDown={props.onKeyDown}
            />
            <div
                ref={props.resultRef}
                className={`search-result-container ${props.showResult ? 'show' : 'hide'}`}
            >
                {props.searchResult.results.length > 0 || props.searchResult.quickLinks.length > 0 ?
                    <>
                        {props.searchQuery ?
                            props.searchResult.results.length === 0 ?
                                (
                                    <div className={'empty-search-result__container'}>
                                   <span
                                       className={'empty-search-result__container-text'}>
                                    showing result for "{props.searchQuery}"
                                   </span>
                                        <Empty className={'empty-search-result__container-icon'}/>
                                    </div>
                                )
                                :
                                (<div className={'result'}>
                                    <span className={'result__title'}>
                                      Result
                                    </span>
                                    {props.searchResult.results.map((item, index) => {
                                        return (
                                            <SearchResultItem
                                                key={item.id}
                                                item={item}
                                                handleNavigation={props.handleNavigation}
                                                isActive={props.activeIndex === index}
                                            />
                                        )
                                    })}
                                </div>)
                            :
                            (
                                <>
                                </>
                            )
                        }
                        <div className={'quickLinks'}>
                      <span className={'quickLinks__title'}>
                          QuickLink
                         </span>
                            {props.searchResult.quickLinks.map((item, index) => {
                                const currentIndex = props.searchResult.results.length + index;
                                return (
                                    <SearchResultItem
                                        item={item}
                                        key={item.id}
                                        handleNavigation={props.handleNavigation}
                                        isActive={props.activeIndex === currentIndex}
                                    />
                                )
                            })}
                        </div>
                    </> :
                    (
                        <div className={'empty-search-result__container'}>
                            <span
                                className={'empty-search-result__container-text'}>
                                No result found
                            </span>
                            <Empty className={'empty-search-result__container-icon'}/>
                        </div>
                    )
                }

            </div>
        </div>
    );
};

export default SearchView;
